import { createSlice } from "@reduxjs/toolkit";

type ModalState = {
  toasts: {
    id: string;
    message: string;
    type: "error" | "success";
    duration: number;
  }[];
};

const initialState: ModalState = {
  toasts: [],
};

const toastSlice = createSlice({
  name: "toast",
  initialState,
  reducers: {
    showToast(
      state,
      action: { payload: { id: string; message: string; type: "error" | "success"; duration?: number } },
    ) {
      state.toasts.push({
        id: action.payload.id,
        message: action.payload.message,
        type: action.payload.type,
        duration: action.payload.duration || 3000,
      });
    },
    hideToast(state, action: { payload: string }) {
      state.toasts = state.toasts.filter((toast) => toast.id !== action.payload);
    },
  },
});

export const { showToast, hideToast } = toastSlice.actions;
export default toastSlice.reducer;
